import { Link } from 'react-router-dom';

import FullScreenDropdown from 'components/Common/FullScreenDropdown';
import LanguageDropdown from 'components/Common/LanguageDropdown';
import ProfileDropdown from 'components/Common/ProfileDropdown';
import { useAppDispatch, useAppSelector } from 'slices';
import { changeSidebarVisibility } from 'slices/sidebar/reducer';
// import AILogo from 'components/Common/AIChatButton';

const Header = () => {
  const dispatch = useAppDispatch();

  const { visibility } = useAppSelector(state => state.Layout);
  // Inside your component

  const toggleMenuBtn = () => {
    var windowSize = document.documentElement.clientWidth;
    const humberIcon = document.querySelector('.hamburger-icon') as HTMLElement;
    dispatch(changeSidebarVisibility('show'));

    if (windowSize > 767) humberIcon.classList.toggle('open');

    // For collapse vertical and semibox menu
    if (
      visibility === 'show' &&
      (document.documentElement.getAttribute('data-layout') === 'vertical' ||
        document.documentElement.getAttribute('data-layout') === 'semibox')
    ) {
      const currentSize = document.documentElement.getAttribute('data-sidebar-size');

      if (windowSize < 1025 && windowSize > 767) {
        document.body.classList.remove('vertical-sidebar-enable');
        document.documentElement.setAttribute('data-sidebar-size', currentSize === 'sm' ? '' : 'sm');
      } else if (windowSize > 1025) {
        document.body.classList.remove('vertical-sidebar-enable');
        document.documentElement.setAttribute('data-sidebar-size', currentSize === 'sm' ? 'lg' : 'sm');
      } else if (windowSize <= 767) {
        document.body.classList.add('vertical-sidebar-enable');
        document.documentElement.setAttribute('data-sidebar-size', 'lg');
      }
    }

    // Two column menu
    if (document.documentElement.getAttribute('data-layout') === 'twocolumn') {
      document.body.classList.contains('twocolumn-panel')
        ? document.body.classList.remove('twocolumn-panel')
        : document.body.classList.add('twocolumn-panel');
    }
  };
  return (
    <header id="page-topbar">
      <div className="layout-width">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box horizontal-logo">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src="../src/assets/images/logo.svg" alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src="../src/assets/images/logo.svg" alt="" height="17" />
                </span>
              </Link>
              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src="../src/assets/images/logo.svg" alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src="../src/assets/images/logo.svg" alt="" height="17" />
                </span>
              </Link>
            </div>
            <button
              onClick={toggleMenuBtn} // Відкриття бокового меню
              type="button"
              className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
              id="topnav-hamburger-icon"
            >
              <span className="hamburger-icon">
                <span />
                <span />
                <span />
              </span>
            </button>
          </div>

          <div className="d-flex align-items-center">
            {/* <AILogo /> */}
            <LanguageDropdown />
            <FullScreenDropdown />
            <ProfileDropdown />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
